module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SelectMallCoinListView.js"));
	}, "SelectMallCoinListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SelectMallCoinListView!./src/pages/Shop/Member/Personal/SelectMall/SelectMallCoinList/SelectMallCoinListView.js
// module id = 1515
// module chunks = 418